import { useEffect, useRef } from 'react';
import { type TableSelectedCell, useTableRows } from '@/components/custom/erp';
import { isValidUUID } from '@/lib/uuid-validator';

export interface DetailRow {
  uuid?: string | null;
  [key: string]: any;
}

export type SelectedCellInfo = TableSelectedCell;

const createFieldUpdates = (field: string, value: any, isPastingRef: React.MutableRefObject<boolean>) => {
  let processedValue = value;

  if (field === 'ps_nt' || field === 'ps' || field === 'ty_gia2') {
    if (value === '' || value === null || value === undefined) {
      processedValue = value;
    } else {
      const numValue = Number(value);
      processedValue = Number.isNaN(numValue) ? 0 : numValue;
    }
  }

  const updates: Partial<DetailRow> = { [field]: processedValue };

  if (field === 'ma_kh_data') {
    updates.id_tt = 0;
    updates.id_tt_data = null;
  } else if (field === 'id_tt_data') {
    updates.id_tt = isValidUUID(value?.document_uuid) || 0;
  }

  if (isPastingRef.current && field === 'ma_kh_data') {
    updates.ma_kh_co_data = processedValue;
  }

  return updates;
};

export function useDetailRows(initialRows: DetailRow[] = [], onChange?: (rows: DetailRow[]) => void) {
  const isPastingRef = useRef(false);

  const {
    rows,
    setRows,
    selectedRowUuid,
    setSelectedRowUuid,
    selectedRow,
    setSelectedRow,
    selectedCell,
    setSelectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleCellValueChange,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handlePasteRow,
    handleMoveRow,
    setNonWritableFields,
    setPasteConfigs,
    isPasting
  } = useTableRows<any>({
    initialRows,
    defaultRows: 1,
    onChange,
    onFieldValueChange: (row, field, value): Partial<DetailRow> => createFieldUpdates(field, value, isPastingRef),
    defaultField: 'ma_ngvkt'
  });

  // Update isPastingRef whenever isPasting changes
  useEffect(() => {
    isPastingRef.current = isPasting;
  }, [isPasting]);

  return {
    rows,
    setRows,
    selectedRowUuid,
    selectedRow,
    selectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handlePasteRow,
    handleMoveRow,
    handleCellValueChange,
    setNonWritableFields,
    setPasteConfigs,
    setSelectedRow,
    setSelectedCell,
    isPasting
  };
}
